import { deburr } from 'lodash-es'

const removeMultipleSpaces = str => str.replace(/\s+/g, ' ')
const removeJsonKeys = str => str.replace(/"[^"]+":/g, '')
const removeHtmlTags = str => str.replace(/<[^>]*>/g, ' ')
const removePunctuation = str => str.replace(/["&;:{}[\]=~]/g, ' ')
const safeString = value => (typeof value === 'string' ? value : '')

export const safeArray = value => (Array.isArray(value) ? value : [])

export const normalizeForSearch = str => {
  const cleanedStr = [safeString(str)]
    .map(removeHtmlTags)
    .map(removePunctuation)
    .map(removeMultipleSpaces)
    .reduce(s => s)

  return deburr(cleanedStr.toLowerCase()).trim()
}

export const normalizeJsonForSearch = json => {
  return normalizeForSearch(removeJsonKeys(safeString(json)))
}
